import BottomNavigation from "components/BottomNavigation"
import ImageEditor from "components/ImageEditor"
import { SingleSelectField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FONTS } from "constants/fonts"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row, Tooltip } from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import { updateListScreenSetup } from "store/actions"
import { getFileBlob } from "utils"
import PhonePreview from "./phonePreview"
import { required } from "./utils"
import ColorPicker from "components/ColorPicker"

const HeaderTab = ({
  headerImage,
  change,
  isDirty,
  tabIsActive,
  resetForm,
  listScreenSetup,
  formValues,
  vendorId,
  userId,
  updateListScreenSetup,
  handleBack,
  handleNext,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const onSave = () => {
    updateListScreenSetup({
      values: {
        ...listScreenSetup,
        header_font: formValues?.textFont,
        header_tab_color: formValues?.headerColor,
        header_text_color: formValues?.textColor,
        my_events_text: formValues?.title,
        ...(formValues?.deleteImage ? { delete_image: 1 } : {}),
      },
      uploadHeaderImage:
        formValues?.deleteImage && formValues?.image?.editedImage
          ? true
          : false,
      headerImage: {
        vendor_id: vendorId,
        dir: "background",
        user_id: userId,
        "resize[height]": 250,
        "resize[quality]": 80,
        files: [
          getFileBlob(formValues?.image && formValues?.image?.editedImage),
        ],
      },
    })
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Header</h4>
            </CardHeader>
            <CardBody>
              <Row className="my-3">
                <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Add color:</label>
                </Col>
                <Col xs="auto">
                  <Field name="headerColor" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>
                    Add image:&nbsp;
                    <i
                      className="fas fa-question-circle"
                      id="listScreenHeader"
                    ></i>
                    &nbsp;
                  </label>
                  <Tooltip
                    placement="top"
                    isOpen={tooltipOpen}
                    target="listScreenHeader"
                    toggle={toggle}
                  >
                    <b>NOTE:</b> For best results, use an image with 200px
                    height and no wider than 500px
                  </Tooltip>
                </Col>
                <Col xs="auto" className="my-1">
                  <Field
                    name="image"
                    type="file"
                    component={ImageEditor}
                    onDelete={() => {
                      change("header.deleteImage", 1)
                    }}
                    onChange={() => {
                      change("header.deleteImage", 1)
                    }}
                  />
                </Col>
                <Col className="d-flex flex-row justify-content-end">
                  {headerImage && headerImage?.editedImage && (
                    <img
                      src={
                        headerImage?.editedImage ? headerImage?.editedImage : ""
                      }
                      alt="headerImage"
                      className="rounded avatar-xl"
                      style={{ blockSize: "auto" }}
                    />
                  )}
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Add text title:</label>
                </Col>
                <Col xs="auto">
                  <div style={{ width: "270px" }}>
                    <Field
                      name="title"
                      component={TextField}
                      placeholder="Text title"
                      validate={[required]}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Text font:</label>
                </Col>
                <Col xs="auto">
                  <div style={{ width: "270px" }}>
                    <Field
                      className="full-width"
                      name="textFont"
                      component={SingleSelectField}
                      options={FONTS.map(font => ({
                        value: font.value,
                        label: font.text,
                      }))}
                      placeholder="Select Font Family"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Text color:</label>
                </Col>
                <Col xs="auto">
                  <Field name="textColor" component={ColorPicker} />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleBack={handleBack}
            handleNext={handleNext}
            handleSave={onSave}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          onSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST_SCREEN)

const mapStateToProps = state => ({
  headerImage: selector(state, "header.image"),
  formValues: selector(state, "header"),
  isDirty: isDirty(FORM_NAMES.LIST_SCREEN)(state, ...["header"]),
  listScreenSetup: state.ListScreen.listScreenSetup,
  userId: state.Login.authUser.id,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.LIST_SCREEN, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.LIST_SCREEN)),
  updateListScreenSetup: values => dispatch(updateListScreenSetup(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTab)
